export const GAME_TIME = 'GAME_TIME';
export const OPPONENT_CITY = 'OPPONENT_CITY';
export const SECTION_NUMBER = 'SECTION_NUMBER';
export const SEAT_NUMBER = 'SEAT_NUMBER';
export const STADIUM_PACKAGE = 'STADIUM_PACKAGE';
export const PACKAGE_ID = 'PACKAGE_ID';
export const OPPONENT_NAME = 'OPPONENT_NAME';
export const ROW_NUMBER = 'ROW_NUMBER';
